import React, { useContext, useEffect } from 'react';
import {
    Heading, Button
} from '@americanexpress/dls-react';
import {
    PersonnelInformation,
    EmploymentType,
    Error,
    ContactInformation,
    TermsAndConditions
} from '../../components';
import UserContext from '../../components/ContextComponent/UserContext';
import { CONSTANTS } from '../../constants';
import { useHistory } from 'react-router-dom';


function StageOne(props) {
    const history = useHistory();
    const { formData } = useContext(UserContext);
    const { errorData, setErrorData } = useContext(UserContext);

    useEffect(() => {
        history.push('/Acquisition');
    },[]);
    
   
    const handleOnClick = (e) => {
        if(formData.title === ''){
            setErrorData({ ...errorData, titleRequired: true });
        }
        else if(formData.firstName === ''){
            setErrorData({ ...errorData, firstNameRequired: true });
        }
        else if(formData.lastName === ''){
            setErrorData({ ...errorData, lastNameRequired: true });
        }
        else if(formData.dateOfBirth === ''){
            setErrorData({ ...errorData, dateOfBirthRequired: true });
        } 
        else if(formData.panNumber ==='' && formData.haveForm60 === false){
            setErrorData({ ...errorData, panNumberRequired: true });
        }
        else if(formData.email === ''){
            setErrorData({ ...errorData, emailRequired: true });
        } 
        else if(formData.mobileNumber === '' || !CONSTANTS.validation.mobilePattern.test(formData.mobileNumber)){
            setErrorData({ ...errorData, mobileNumberRequired: true });
        }
        else if (formData.homeAddressLine1 === '' || formData.homeAddressLine1.length < 3) {
            setErrorData({ ...errorData, invalidHomeAddressLine1Pattern: true });
        }
        else if (!CONSTANTS.validation.addressPattern.test(formData.homeAddressLine1)) {
            setErrorData({ ...errorData, invalidHomeAddressLine1Pattern:true})
        }
        else if (formData.homeAddressLine1.length > 35) {
            setErrorData({ ...errorData, homeAddressLine1Length:true})
        }
        else if (formData.homeAddressLine2 === ''){
            setErrorData({ ...errorData, homeAddressLine2Required: true });
        }
        else if (!CONSTANTS.validation.addressPattern.test(formData.homeAddressLine2)) {
            setErrorData({ ...errorData, invalidHomeAddressLine2Pattern: true })
        }
        else if (formData.homeAddressLine2.length > 35) {
            setErrorData({ ...errorData, homeAddressLine2Length: true })
        }
        else if (formData.homeAddressLine3 === ''){
            setErrorData({ ...errorData, homeAddressLine3Required: true });
        }
        else if (!CONSTANTS.validation.addressPattern.test(formData.homeAddressLine3)) {
            setErrorData({ ...errorData, invalidHomeAddressLine3Pattern: true })
        }
        else if (formData.homeAddressLine3.length > 35) {
            setErrorData({ ...errorData, homeAddressLine3Length: true })
        }
        else if(formData.homePin === ''){
            setErrorData({ ...errorData, homePinRequired: true });
        } 
        else if(formData.homeCity === ''){
            setErrorData({ ...errorData, homeCityRequired: true });
        } 
        else if(formData.homeState === ''){
            setErrorData({ ...errorData, homeStateRequired: true });
        } 
        else if(formData.employmentStatus === ''){
            setErrorData({ ...errorData, employmentStatusRequired: true });
        } 
        else if (formData.annualIncome === '' &&
            formData.employmentStatus !== CONSTANTS.employmentStatus.student                    
            ) {
            setErrorData({ ...errorData, annualIncomeRequired: true });
        }
        else if (formData.disclaimer === '' || formData.disclaimer === false) {
            setErrorData({ ...errorData, disclaimerRequired: true });
        } 
        else
        {
            setErrorData({
                ...errorData,
                titleRequired: false,
                firstNameRequired: false,
                lastNameRequired: false,
                dateOfBirthRequired: false,
                panNumberRequired: false,
                emailRequired: false,
                mobileNumberRequired: false,
                homePinRequired: false,
                homeCityRequired: false,
                homeStateRequired: false,
                employmentStatusRequired: false,
                annualIncomeRequired: false,
                disclaimerRequired: false,                
                homeAddressLine1Required: false,
                homeAddressLine1Length: false,
                invalidHomeAddressLine1Pattern: false,
                homeAddressLine2Required: false,
                homeAddressLine2Length: false,
                invalidHomeAddressLine2Pattern: false,
                homeAddressLine3Required: false,
                invalidHomeAddressLine3Pattern: false,
                homeAddressLine3Length: false
            });
        }
    }
    return (
        <>
            {/*<form onSubmit={props.handleSubmit}>
                <div className="pad-responsive">
                    <div className="stack body">
                        {props.data && (
                            <div className="stack-a">
                                <Error errorList={props.validation} />
                            </div>
                        )}
                        <Heading level={3} headingStyle="heading3" className="margin-2-b"> PLEASE TELL US ABOUT YOURSELF </Heading>
                        <Heading level={2} className="body-1 margin-1-b font-weight-normal">All fields are required unless marked as optional.</Heading>
                        <PersonnelInformation handleOnClick={handleOnClick} />
                        <ContactInformation />
                        <div className="stack pad-3-b">
                            <Heading level={3} headingStyle="heading3" className="margin-2-b text-uppercase">Additional Information </Heading>
                            <EmploymentType onChange={false} />
                        </div>
                        {props.data && (
                            <div className="stack-a">
                                <TermsAndConditions terms={props.data.journeyContent.agreePostamble} />
                            </div>
                        )}
                    </div>
                </div>
                <div className="flex flex-column flex-align-items-center pad-responsive">
                    <Button aria-label="Submit" type="submit" styleType="primary" 
                    onClick={handleOnClick}
                    >Agree and continue</Button>
                </div>
            </form>*/}
        </>
    );
}

export default StageOne;